import { cva } from 'class-variance-authority';

export const avatarVariants = cva('rounded-full', {
  variants: {
    variant: {
      xs: 'h-8 w-8',
      sm: 'h-9 w-9'
    }
  },
  defaultVariants: {
    variant: 'xs'
  }
});
